import React from 'react';
import Icon from '../../../components/AppIcon';
import StatusIndicatorBadge from '../../../components/ui/StatusIndicatorBadge';

const RecentActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      'registration': 'FileText',
      'approval': 'CheckCircle',
      'rejection': 'XCircle',
      'message': 'MessageSquare',
      'export': 'Download',
      'review': 'Eye'
    };
    return iconMap?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      'registration': 'var(--color-primary)',
      'approval': 'var(--color-success)',
      'rejection': 'var(--color-error)',
      'message': 'var(--color-accent)',
      'export': 'var(--color-secondary)',
      'review': 'var(--color-warning)'
    };
    return colorMap?.[type] || 'var(--color-muted-foreground)';
  };

  return (
    <div className="card">
      <h3 className="text-lg font-semibold text-foreground mb-4">Recent Activity</h3>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start gap-3 pb-4 border-b border-border last:border-0 last:pb-0">
            <div 
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
              style={{ backgroundColor: `${getActivityColor(activity?.type)}15` }}
            >
              <Icon name={getActivityIcon(activity?.type)} size={18} color={getActivityColor(activity?.type)} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">{activity?.title}</p>
              <p className="text-xs text-muted-foreground mb-2">{activity?.description}</p>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs text-muted-foreground">{activity?.timestamp}</span>
                {activity?.status && <StatusIndicatorBadge status={activity?.status} />}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivityFeed;